export default "__VITE_ASSET__D2YgRN9J__"